import 'babel-polyfill'
import './globals'
import 'styles'
import { processLoginCallback, processingHash } from 'user'
import * as pages from 'pages'
import store from 'store'

m.route.prefix('')

function checkForAuthentication() {
  const { loggedIn } = store.getState().user
  if(!loggedIn) {
    m.route.set('/login')
    return new Promise( (r, reject) => setTimeout(reject, 0)) // chrome's debugger...
  }
  return Promise.resolve()
}

const apply ={
  onmatch() {
    return checkForAuthentication()
      .then( () => {
        const { profile } = store.getState().user
        if(profile.state !== 'need_application') {
          m.route.set('/')
          return new Promise( (r, reject) => setTimeout(reject, 0)) // chrome's debugger...
        }
      })
  }
  , render({ attrs }) {
    return m(pages.Layout, m(pages.ApplyPage, attrs))
  }
}

const mainContainer = document.getElementById('main-js-container') || document.body
Promise.resolve(processingHash).then( () => {
  m.route(mainContainer, '/', {
    '/login': {
      render() {
        return m(pages.OuterLayout, m(pages.LoginPage))
      }
    }
    , '/doLogin': {
      onmatch() {
        return processLoginCallback()
      }
    }
    , '/apply': apply
    , '/apply/:step': apply
    , '/prefill': { view() { return m('div', 'TODO') } }
    , '/': {
      onmatch() {
        // handle "cancellation"
        return new Promise( (resolve) => checkForAuthentication()
            .then( () => {
              const { profile: { state } } = store.getState().user
              if(state === 'need_application') {
                m.route.set('/apply')
              } else if(state === 'active') {
                return pages.MainPage
              } else {
                return { view() { return m('div', 'TODO state...') } }
              }
            })
            .catch( () => null)
            .then(resolve))
      }
      , render(component) {
        return m(pages.Layout, component)
      }
    }
  })
})
